import { MasterReducer, Generator } from '../../utils/store';
import { select, put, call } from 'redux-saga/effects';

import * as Constants from '../../utils/constants';
import * as Functions from '../../utils/functions';

const key = 'Camera';
const playerKey = 'CameraPlayer';

export const Reducer = new MasterReducer(
  key,
  {
    stream: null,
    player: null,
    imageUrl: null,
    imageFile: null,
    facingMode: Constants.Camera.FacingMode.User.code,
    isOpen: false,
    payload: {},
  },
  {
    ...Generator.makePureActions('open', function* (returnAction, self) {
      const values = yield select(self.makeSelector('values'));
      const stream = yield select(self.makeSelector('stream'));
      if (stream) {
        stream.getTracks().forEach((track) => { track.stop(); });
      }
      const payload = yield call(
        Functions.Browser.initializeVideoStream,
        playerKey,
        values.facingMode || Constants.Camera.FacingMode.User.code,
      );

      yield put(self.actionCreators.setStates({
        ...self.initialState,
        isOpen: true,
        payload: values,
        stream: payload.stream,
        player: payload.player,
      }));
    }),

    ...Generator.makePureActions('close', function* (returnAction, self) {
      const stream = yield select(self.makeSelector('stream'));
      if (stream) {
        stream.getTracks().forEach((track) => { track.stop(); });
      }

      yield put(self.actionCreators.setStates({
        isOpen: false,
      }));
    }),

    ...Generator.makePureActions('capture', function* (returnAction, self) {
      const player = yield select(self.makeSelector('player'));
      const payload = yield select(self.makeSelector('payload'));
    
      var canvas = document.createElement("canvas");
      canvas.width = player.videoWidth;
      canvas.height = player.videoHeight;
      var context = canvas.getContext("2d");
      context.drawImage(player, 0, 0, canvas.width, canvas.height);
    
      // convert to Blob (async)
      canvas.toBlob((blob) => {
        const file = new File([blob], "camera.png", {type: "image/png"});
        const url = URL.createObjectURL(blob);
    
        self.dispatcher.setStates({
          imageUrl: url,
          imageFile: file,
        });
        self.dispatcher.close();

        if (payload.onResultCallback) {
          payload.onResultCallback(file);
        }
      });
    }),

    ...Generator.makePureActions('switchCamera', function* (returnAction, self) {
      const facingMode = yield select(self.makeSelector('facingMode'));
      var newFacingMode = facingMode;
    
      if (facingMode === Constants.Camera.FacingMode.User.code) {
        newFacingMode = Constants.Camera.FacingMode.Environment.code;
      }
      else if (facingMode === Constants.Camera.FacingMode.Environment.code) {
        newFacingMode = Constants.Camera.FacingMode.User.code;
      }
    
      yield put(self.actionCreators.open({
        facingMode: newFacingMode,
      }));
    }),
  }
);

export default Reducer;

export const reducer = Reducer.reducer;
export const saga = Reducer.saga;